module.exports = __webpack_public_path__ + "static/media/offering-image-one.8d53c45e.png";